import { Model, modelRegistry } from './Model';
export class Shortcut extends Model {
    static entity = 'shortcuts';
    id = null;
    name = null;
    value = null;
    created_at = null;
    updated_at = null;
    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            value: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
}
export default Shortcut;
modelRegistry.register('Shortcut', Shortcut);
//# sourceMappingURL=Shortcut.js.map